import { Button as AntdButton, ButtonProps as AntdButtonProps } from "antd";

interface ButtonProps extends AntdButtonProps {
  lighter?: boolean;
  light?: boolean;
  full?: boolean;
  link?: boolean;
  shadow?: boolean;
  large?: boolean;
  loading?: boolean;
}

export default function Button({
  children,
  className,
  lighter,
  light,
  full,
  link,
  shadow,
  large,
  loading,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  type,
  ...attrs
}: ButtonProps) {
  className = (className || "") + " Button rounded-full! h-10! items-center";

  if (!shadow) {
    className += " shadow-none!";
  }

  if (lighter) {
    className += " wish-background-lighter text-black";
  } else if (light) {
    className += " bg-white wish-color-active hover:wish-bg-active";
  } else if (!link) {
    className += " wish-bg-active wish-text-white";
  }

  if (full) {
    className += " w-full";
  } else {
    className += " w-min";
  }

  return (
    <AntdButton
      className={className}
      {...attrs}
      type={link ? "link" : "default"}
      size={large ? "large" : undefined}
      block={large ? true : undefined}
      loading={loading}
    >
      {children}
    </AntdButton>
  );
}
